import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../components/LanguageSelector";
import "./Rgpd.css";

export default function Rgpd() {
  const { i18n } = useTranslation();

  if (i18n.language === "fr") {
    return (
      <>
        {""}
        <div className="App">
          <header className="App-header">
            <img
              src={require("../assets/logo.jpg")}
              alt="Logo"
              style={{ width: "240px" }}
            />
            <div></div>
          </header>
        </div>

        <div className="App2">
          <div />
          <LanguageSelector />

          {/**************************************************************/}
          {/** FR  *******************************************************/}
          {/**************************************************************/}

          <div className="rgpd-content">
            <h2>
              {" "}
              Politique de confidentialité et protection des données
              personnelles
            </h2>

            <ol>
              <li>
                <h3>Informations sur le responsable du traitement</h3>
                <p>
                  <strong>Identité de l’organisateur :</strong>
                </p>
                <ul>
                  <li>
                    BAPP – Belgian Association of Promotional Products (ASBL)
                  </li>
                  <li>Imperiastraat, 6, 1930 Zaventem</li>
                  <li>+32 2 883 11 98</li>
                  <li>
                    <a href="mailto:info@bapp.be">info@bapp.be</a>
                  </li>
                </ul>

                <p>
                  <strong>Délégué à la protection des données (DPO) :</strong>
                </p>
                <ul>
                  <li>Linda YALMAN</li>
                  <li>
                    <a href="mailto:info@bapp.be">info@bapp.be</a>
                  </li>
                  <li>+32 2 883 11 98</li>
                </ul>

                <p>
                  L’organisateur, en tant que responsable du traitement,
                  garantit la protection et la confidentialité des données
                  personnelles des exposants et visiteurs collectées lors de
                  l’événement et via l’utilisation de l’application.
                </p>
              </li>

              <li>
                <h3>Finalité du traitement</h3>
                <p>
                  Les données personnelles des exposants et des visiteurs sont
                  collectées lors de l’enregistrement préalable à l’événement
                  dans le but de :
                </p>
                <ul>
                  <li>Identifier les participants (exposants et visiteurs)</li>
                  <li>
                    Gérer l’attribution des badges contenant des informations
                    personnelles et un QR code
                  </li>
                  <li>
                    Faciliter l’échange de coordonnées via le scan de QR code
                  </li>
                  <li>
                    Permettre aux utilisateurs d’enregistrer des cartes de
                    visite sur leur smartphone
                  </li>
                  <li>
                    Analyser et améliorer l’expérience de networking (de manière
                    agrégée et anonymisée)
                  </li>
                </ul>
                <p>
                  Le traitement repose sur l’exécution d’un contrat et/ou le
                  consentement préalable de la personne concernée.
                </p>
              </li>

              <li>
                <h3>Données collectées</h3>
                <ul>
                  <li>
                    Informations issues de l’enregistrement : nom, entreprise,
                    email, etc.
                  </li>
                  <li>Données figurant sur le badge (identité + QR code)</li>
                  <li>
                    Informations scannées via l’application (coordonnées, infos
                    validées)
                  </li>
                </ul>
                <p>
                  Ces données permettent d’identifier les participants et de
                  faciliter l’échange de contacts durant l’événement.
                </p>
              </li>

              <li>
                <h3>Méthodes de collecte et d’utilisation</h3>
                <p>
                  <strong>Collecte initiale :</strong>
                </p>
                <p>
                  Les données sont collectées via le formulaire d’inscription.
                </p>

                <p>
                  <strong>Collecte via l’application :</strong>
                </p>
                <p>
                  Lors du scan d’un QR code, les données du badge sont partagées
                  et affichées dans l’application.
                </p>

                <p>
                  <strong>Support technique :</strong>
                </p>
                <p>
                  Les échanges ont lieu via l’application et peuvent être
                  stockés dans un cloud externe si nécessaire.
                </p>
              </li>

              <li>
                <h3>Partage et transferts des données</h3>

                <p>
                  <strong>Destinataires internes :</strong>
                </p>
                <p>
                  Seuls les services autorisés de l’organisateur y ont accès.
                </p>

                <p>
                  <strong>Destinataires externes :</strong>
                </p>
                <p>
                  Seuls les prestataires techniques (hébergement, maintenance)
                  liés par une obligation de confidentialité ont accès aux
                  données.
                </p>

                <p>
                  <strong>Transferts internationaux :</strong>
                </p>
                <p>
                  Aucun transfert hors UE n’a lieu sauf si des garanties
                  adéquates sont en place et que les utilisateurs sont
                  préalablement informés.
                </p>
              </li>

              <li>
                <h3>Durée de conservation des données</h3>
                <p>
                  Les données sont conservées pendant l’événement et une période
                  raisonnable après celui-ci, puis supprimées ou anonymisées.
                </p>
              </li>

              <li>
                <h3>Sécurité des données</h3>
                <ul>
                  <li>Chiffrement des échanges via l’application</li>
                  <li>Accès restreint aux personnes autorisées</li>
                  <li>Systèmes de sauvegarde et vérifications régulières</li>
                </ul>
                <em>
                  Pensez à ajouter des détails sur la gestion des mots de passe
                  et la formation du personnel.
                </em>
              </li>

              <li>
                <h3>Droits des personnes concernées</h3>
                <ul>
                  <li>
                    <strong>Droit d’accès :</strong> demander l’accès à vos
                    données
                  </li>
                  <li>
                    <strong>Droit de rectification :</strong> corriger les
                    données inexactes
                  </li>
                  <li>
                    <strong>Droit à l’effacement :</strong> demander la
                    suppression (dans les limites légales)
                  </li>
                  <li>
                    <strong>Droit à la limitation :</strong> demander la
                    limitation du traitement
                  </li>
                  <li>
                    <strong>Droit d’opposition :</strong> s’opposer à
                    l’utilisation à des fins de prospection/analytique
                  </li>
                  <li>
                    <strong>Droit à la portabilité :</strong> recevoir vos
                    données dans un format standard
                  </li>
                </ul>
                <p>Pour exercer ces droits, veuillez contacter le DPO.</p>
              </li>

              <li>
                <h3>Procédure de réclamation</h3>
                <p>
                  Vous pouvez adresser une réclamation à l’organisateur ou à
                  l’autorité compétente :
                </p>
                <ul>
                  <li>
                    <strong>Autorité de protection des données (APD) :</strong>{" "}
                    <a
                      href="https://www.autoriteprotectiondonnees.be"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.autoriteprotectiondonnees.be
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <h3>Modifications de la politique de confidentialité</h3>
                <p>
                  Cette politique peut être modifiée pour des raisons juridiques
                  ou techniques. En cas de changement majeur, vous serez notifié
                  via l’application ou par email.
                </p>
              </li>

              <li>
                <h3>Acceptation de la politique de confidentialité</h3>
                <p>
                  En utilisant le formulaire, vous acceptez cette politique et
                  consentez au traitement de vos données. Le consentement sera
                  requis avant l’envoi du formulaire.
                </p>
              </li>
            </ol>
          </div>
        </div>
      </>
    );
  } else if (i18n.language === "nl") {
    return (
      <>
        {""}
        <div className="App">
          <header className="App-header">
            <img
              src={require("../assets/logo.jpg")}
              alt="Logo"
              style={{ width: "240px" }}
            />
            <div></div>
          </header>
        </div>

        <div className="App2">
          <div />
          <LanguageSelector />

          {/**************************************************************/}
          {/** NL  *******************************************************/}
          {/**************************************************************/}

          <div className="rgpd-content">
            <h2> Privacybeleid en Bescherming van Persoonsgegevens</h2>

            <ol>
              <li>
                <h3>Informatie over de Verwerkingsverantwoordelijke</h3>
                <p>
                  <strong>Identiteit van de organisator:</strong>
                </p>
                <ul>
                  <li>
                    BAPP – Belgian Association of Promotional Products (ASBL)
                  </li>
                  <li>Imperiastraat, 6, 1930 Zaventem</li>
                  <li>+32 2 883 11 98</li>
                  <li>
                    <a href="mailto:info@bapp.be">info@bapp.be</a>
                  </li>
                </ul>

                <p>
                  <strong>Functionaris voor gegevensbescherming (DPO):</strong>
                </p>
                <ul>
                  <li>Linda YALMAN</li>
                  <li>
                    <a href="mailto:info@bapp.be">info@bapp.be</a>
                  </li>
                  <li>+32 2 883 11 98</li>
                </ul>

                <p>
                  De organisator, als verwerkingsverantwoordelijke, zorgt voor
                  de bescherming en vertrouwelijkheid van de persoonsgegevens
                  van exposanten en bezoekers die tijdens het evenement en via
                  de app zijn verzameld.
                </p>
              </li>

              <li>
                <h3>Doel van de Verwerking</h3>
                <p>
                  De persoonsgegevens van exposanten en bezoekers worden
                  verzameld tijdens de voorregistratie voor het evenement met
                  als doel:
                </p>
                <ul>
                  <li>
                    Identificatie van deelnemers (exposanten en bezoekers)
                  </li>
                  <li>
                    Beheer van de toewijzing van badges met persoonlijke
                    informatie en QR-code
                  </li>
                  <li>
                    Vergemakkelijken van het uitwisselen van contactgegevens via
                    QR-scanning
                  </li>
                  <li>
                    Gebruikers toestaan contactkaarten op hun smartphone op te
                    slaan
                  </li>
                  <li>
                    Analyse en verbetering van de netwerkervaring (geaggregeerd
                    en geanonimiseerd)
                  </li>
                </ul>
                <p>
                  De verwerking is gebaseerd op het uitvoeren van een contract
                  en/of voorafgaande toestemming.
                </p>
              </li>

              <li>
                <h3>Verzamelde Gegevens</h3>
                <ul>
                  <li>
                    Informatie uit registratie: naam, bedrijf, e-mail, enz.
                  </li>
                  <li>Gegevens op de badge (identiteit + QR-code)</li>
                  <li>
                    Gescande info via de app (contactgegevens, goedgekeurde
                    info)
                  </li>
                </ul>
                <p>
                  Deze informatie helpt bij het identificeren van deelnemers en
                  het vergemakkelijken van het uitwisselen van gegevens tijdens
                  het evenement.
                </p>
              </li>

              <li>
                <h3>Methoden van Gegevensverzameling en Gebruik</h3>
                <p>
                  <strong>Eerste verzameling:</strong>
                </p>
                <p>
                  De gegevens worden verzameld via het registratieformulier.
                </p>

                <p>
                  <strong>Verzameling via de app:</strong>
                </p>
                <p>
                  Bij het scannen van een QR-code worden badgegegevens gedeeld
                  en weergegeven.
                </p>

                <p>
                  <strong>Technische ondersteuning:</strong>
                </p>
                <p>
                  Gegevensuitwisseling gebeurt via de app en kan worden
                  opgeslagen in een externe cloud indien nodig.
                </p>
              </li>

              <li>
                <h3>Delen en Overdracht van Gegevens</h3>
                <p>
                  <strong>Interne ontvangers:</strong>
                </p>
                <p>
                  Alleen geautoriseerd personeel van de organisator heeft
                  toegang.
                </p>

                <p>
                  <strong>Externe ontvangers:</strong>
                </p>
                <p>
                  Alleen technische dienstverleners (hosting, onderhoud) met
                  geheimhoudingsplicht hebben toegang tot de gegevens.
                </p>

                <p>
                  <strong>Internationale overdrachten:</strong>
                </p>
                <p>
                  Geen overdracht buiten de EU, tenzij de juiste
                  beschermingsmaatregelen zijn getroffen en gebruikers vooraf
                  zijn geïnformeerd.
                </p>
              </li>

              <li>
                <h3>Bewaartermijn van Gegevens</h3>
                <p>
                  Persoonsgegevens worden bewaard tijdens en kort na het
                  evenement. Daarna worden ze verwijderd of geanonimiseerd.
                </p>
              </li>

              <li>
                <h3>Gegevensbeveiliging</h3>
                <ul>
                  <li>Versleuteling van gegevensuitwisseling via de app</li>
                  <li>Beperkte toegang voor geautoriseerd personeel</li>
                  <li>Back-upsystemen en regelmatige controles</li>
                </ul>
                <em>
                  Overweeg informatie toe te voegen over wachtwoordbeveiliging
                  en personeelsopleiding.
                </em>
              </li>

              <li>
                <h3>Rechten van Betrokkenen</h3>
                <ul>
                  <li>
                    <strong>Recht op inzage:</strong> toegang tot uw gegevens
                    vragen
                  </li>
                  <li>
                    <strong>Recht op rectificatie:</strong> onjuiste gegevens
                    corrigeren
                  </li>
                  <li>
                    <strong>Recht op wissing:</strong> verwijdering van gegevens
                    vragen (binnen wettelijke grenzen)
                  </li>
                  <li>
                    <strong>Recht op beperking:</strong> beperking van
                    verwerking vragen
                  </li>
                  <li>
                    <strong>Recht op bezwaar:</strong> bezwaar maken tegen
                    gebruik voor marketing/analyse
                  </li>
                  <li>
                    <strong>Recht op overdraagbaarheid:</strong> uw gegevens
                    opvragen in standaardformaat
                  </li>
                </ul>
                <p>
                  Om deze rechten uit te oefenen, neem contact op met de DPO.
                </p>
              </li>

              <li>
                <h3>Klachtenprocedure</h3>
                <p>
                  U kunt een klacht indienen bij de organisator of bij de
                  bevoegde autoriteit:
                </p>
                <ul>
                  <li>
                    <strong>Gegevensbeschermingsautoriteit:</strong>{" "}
                    <a
                      href="https://www.gegevensbeschermingsautoriteit.be"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.gegevensbeschermingsautoriteit.be
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <h3>Wijzigingen in het Privacybeleid</h3>
                <p>
                  Dit beleid kan worden bijgewerkt om juridische of technische
                  redenen. Bij belangrijke wijzigingen wordt u via de app of
                  e-mail op de hoogte gebracht.
                </p>
              </li>

              <li>
                <h3>Aanvaarding van het Privacybeleid</h3>
                <p>
                  Door het formulier te gebruiken, aanvaardt u dit beleid en
                  stemt u in met de verwerking. Toestemming wordt gevraagd voor
                  het indienen van het formulier.
                </p>
              </li>
            </ol>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        {""}
        <div className="App">
          <header className="App-header">
            <img
              src={require("../assets/logo.jpg")}
              alt="Logo"
              style={{ width: "240px" }}
            />

            <div></div>
          </header>
        </div>
        <div className="App2">
          <div />
          <LanguageSelector />
          {/**************************************************************/}
          {/** EN  *******************************************************/}
          {/**************************************************************/}
          <div className="rgpd-content">
            <h2> Privacy Policy and Personal Data Protection</h2>

            <ol>
              <li>
                <h3>Data Controller Information</h3>

                <p>
                  <strong>Organizer's Identity:</strong>
                </p>
                <ul>
                  <li>
                    BAPP – Belgian Association of Promotional Products (ASBL)
                  </li>
                  <li>Imperiastraat, 6, 1930 Zaventem</li>
                  <li>+32 2 883 11 98</li>
                  <li>
                    <a href="mailto:info@bapp.be">info@bapp.be</a>
                  </li>
                </ul>

                <p>
                  <strong>Data Protection Officer (DPO):</strong>
                </p>
                <ul>
                  <li>Linda YALMAN</li>
                  <li>
                    <a href="mailto:info@bapp.be">info@bapp.be</a>
                  </li>
                  <li>+32 2 883 11 98</li>
                </ul>

                <p>
                  The organizer, as the data controller, ensures the protection
                  and confidentiality of personal data of exhibitors and
                  visitors collected during the event and through the use of the
                  application.
                </p>
              </li>

              <li>
                <h3>Purpose of Processing</h3>
                <p>
                  The personal data of exhibitors and visitors were collected
                  during the prior registration for the event for the purpose
                  of:
                </p>
                <ul>
                  <li>Identifying participants (exhibitors and visitors)</li>
                  <li>
                    Managing the allocation of badges with personal info and a
                    QR code
                  </li>
                  <li>
                    Facilitating contact info exchange via QR code scanning
                  </li>
                  <li>
                    Allowing users to save contact cards on their smartphones
                  </li>
                  <li>
                    Analyzing and improving networking experience (aggregated &
                    anonymized)
                  </li>
                </ul>
                <p>
                  The processing is based on the execution of a contract and/or
                  prior consent.
                </p>
              </li>

              <li>
                <h3>Data Collected</h3>
                <ul>
                  <li>
                    Information from registration: name, company, email, etc.
                  </li>
                  <li>Data shown on badge (identity + QR code)</li>
                  <li>
                    Scanned info via the app (contact details, approved info)
                  </li>
                </ul>
                <p>
                  This info helps identify participants and enables data
                  exchange during the event.
                </p>
              </li>

              <li>
                <h3>Collection and Use Methods</h3>
                <p>
                  <strong>Initial Collection:</strong>
                </p>
                <p>Data is collected via the event registration form.</p>

                <p>
                  <strong>Collection via the Application:</strong>
                </p>
                <p>
                  When scanning a QR code, badge data is shared and displayed.
                </p>

                <p>
                  <strong>Technical Support:</strong>
                </p>
                <p>
                  Exchanges happen through the app and are stored in external
                  cloud infrastructure if needed.
                </p>
              </li>

              <li>
                <h3>Data Sharing and Transfers</h3>

                <p>
                  <strong>Internal Recipients:</strong>
                </p>
                <p>Only authorized personnel of the organizer have access.</p>

                <p>
                  <strong>External Recipients:</strong>
                </p>
                <p>
                  Only technical providers (hosting, maintenance) under NDA can
                  access data.
                </p>

                <p>
                  <strong>International Transfers:</strong>
                </p>
                <p>
                  No transfer outside the EU unless proper safeguards are in
                  place and users informed.
                </p>
              </li>

              <li>
                <h3>Data Retention Period</h3>
                <p>
                  Personal data is retained during and shortly after the event.
                  After that, it's deleted or anonymized.
                </p>
              </li>

              <li>
                <h3>Data Security</h3>
                <ul>
                  <li>Encryption of data exchanged via the application</li>
                  <li>Restricted access to authorized personnel</li>
                  <li>Backup systems and regular checks</li>
                </ul>
                <em>
                  Consider adding info about password strength and training of
                  staff.
                </em>
              </li>

              <li>
                <h3>Rights of Data Subjects</h3>
                <ul>
                  <li>
                    <strong>Right of Access:</strong> request access to your
                    data
                  </li>
                  <li>
                    <strong>Right to Rectification:</strong> correct inaccurate
                    data
                  </li>
                  <li>
                    <strong>Right to Erasure:</strong> request deletion (within
                    legal limits)
                  </li>
                  <li>
                    <strong>Right to Restriction:</strong> limit processing
                  </li>
                  <li>
                    <strong>Right to Object:</strong> oppose use for
                    marketing/analytics
                  </li>
                  <li>
                    <strong>Right to Portability:</strong> get your data in a
                    standard format
                  </li>
                </ul>
                <p>To exercise your rights, contact the DPO.</p>
              </li>

              <li>
                <h3>Complaint Procedure</h3>
                <p>
                  You may file a complaint with the organizer or with the
                  relevant authority:
                </p>
                <ul>
                  <li>
                    <strong>Data Protection Authority (DPA):</strong>{" "}
                    <a
                      href="https://www.dataprotectionauthority.be"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.dataprotectionauthority.be
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <h3>Changes to the Privacy Policy</h3>
                <p>
                  This policy may be updated for legal or technical reasons.
                  You’ll be notified via app or email in case of significant
                  changes.
                </p>
              </li>

              <li>
                <h3>Acceptance of the Privacy Policy</h3>
                <p>
                  By using the form, you accept the policy and consent to the
                  processing. Consent will be requested before form submission.
                </p>
              </li>
            </ol>
          </div>
        </div>
      </>
    );
  }
}
// <button onClick={onSubmit2}>test </button>
